import React, { useEffect } from 'react'
import { Card, Grid, Heading } from '@design-systems/canvas-ui'
import type { Banner } from 'graphql/queries/banner/bannerQueries'
import { convertTextToLinks } from '../App/bannerUtils'

type SplashPageProps = {
  banners: Banner[]
}

export const SplashPage = ({ banners }: SplashPageProps) => {
  useEffect(() => {
    document.title = 'PLM - Splash Page'
  }, [])

  return (
    <Card className="hc8-pa-4x">
      {banners.map((banner) => (
        <Grid.Container key={banner.id}>
          <Grid.Item size={{ xs: 12 }}>
            <Heading size={3}>{banner.header}</Heading>
          </Grid.Item>
          <Grid.Item size={{ xs: 12 }}>
            <React.Fragment>
              {convertTextToLinks(banner.message)}
            </React.Fragment>
          </Grid.Item>
        </Grid.Container>
      ))}
    </Card>
  )
}

export default SplashPage
